import styled from '@themes/theme'
import { CommonTxtBoxStyle } from '@styles/base.style'

export const UrgencyMessageWrap = styled.div`
  position: relative;
  width: 100vw;
  transform: translateX(-15px);
  padding: 7px 0;
  overflow: hidden;
  .emergency-bg {
    position: absolute;
    left: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    transform: skew(35deg) translateX(-18px);
    height: 7px;
    &.top {
      top: 0;
    }
    &.bottom {
      bottom: 0;
    }
    .emergency-bar {
      display: block;
      min-width: calc(100% / 16);
      height: inherit;
      &.yellow {
        background: ${props => props.theme.color.yellow};
      }
      &.black {
        background: ${props => props.theme.color.mainBg};
      }
    }
  }
  .notice-contents {
    position: relative;
    width: 100%;
    height: auto;
    padding: 37px 34px;
    background: #fff;
    .close-btn {
      &::before, &::after {
        background: ${props => props.theme.color.modalDarkBg};
      }
    }
    .tit {
      margin-bottom: 8px;
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.xlarge};
    }
    .txt {
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.large};
      ${CommonTxtBoxStyle};
    }
  }

  &.pc-urgency-message-wrap {
    max-width: 414px;
    margin: 0 auto;
    top: 50%;
    transform: translateY(-50%);
    .notice-contents {
      width: 100%;
    }
  }
`
